import { appEnvs } from "@sa-nu/shared-types";
import z from "zod";

export const StripeApiVersionSchema = z.literal("2024-12-18.acacia").optional();

export const AppEnvSchema = z.enum(appEnvs);

/**
 * 壊れていてもアプリを止めたくない任意の http(s) URL (計測の送信先など)。parseEnv は 1 項目の
 * 不正で全体を落とすので、空文字や scheme 抜けは未設定として扱う。
 */
export const NonCriticalUrlSchema = z
  .url({ protocol: /^https?$/ })
  .optional()
  .catch(undefined);

/**
 * ローカルでは optional だが、Vercel 上では必須
 */
export function optionalOnLocal<TWrapped extends z.ZodType>(
  wrapped: TWrapped
): TWrapped | z.ZodOptional<TWrapped> {
  // eslint-disable-next-line no-restricted-syntax
  if (process.env.VERCEL_ENV != null) {
    return wrapped;
  }
  return wrapped.optional();
}

export function parseEnv<Output>(
  schema: z.ZodType<Output>,
  env: NodeJS.ProcessEnv
): Output {
  const result = schema.safeParse(env);
  if (!result.success) {
    const errs = result.error.flatten();
    throw new Error(`Invalid env: ${JSON.stringify(errs)}`);
  }
  return result.data;
}

/**
 * ブラウザでは注入 script (getPublicEnvInjectionScript) が実行済みである前提だが、
 * Next の notFound()/error ドキュメントは `<html id="__next_error__">` の素のシェルで返り
 * layout の inline script が HTML に出ないまま同じ JS が動くため、undefined を返しうる。
 */
export function getPublicEnv<Output>(
  schema: z.ZodType<Output>
): Output | undefined {
  return typeof window === "undefined"
    ? parseEnv(schema, process.env)
    : (window as unknown as { publicEnv?: Output }).publicEnv;
}

export function getPublicEnvInjectionScript(
  publicEnv: Record<string, unknown>
): string {
  return `window.publicEnv = ${JSON.stringify(publicEnv)};`;
}
